import { useEffect } from "react";

const PartnerRedirect = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.replace(
        "https://diy.sharekhan.com/app/Account/Register?grpcd=12688&type=pb&grpid=13118",
      );
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black-main-dark text-white px-6">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-semibold mb-4">
          Redirecting to Our Partner
        </h2>

        <p className="text-gray-300">
          You are being securely redirected to Sharekhan to complete your
          account opening process.
        </p>

        <div className="mt-6 flex justify-center">
          <div className="w-8 h-8 border-4 border-primary1 border-t-transparent rounded-full animate-spin"></div>
        </div>

        <p className="mt-4 text-sm text-gray-400">
          Redirecting in 5 seconds...
        </p>

        <p className="text-xs text-gray-500 mt-6">
          TradeTact Capital Solutions is an authorised partner of Sharekhan.
        </p>
      </div>
    </div>
  );
};

export default PartnerRedirect;
